import { render, staticRenderFns } from "./Trainingsplan.vue?vue&type=template&id=3bb9236c&scoped=true&"
import script from "./Trainingsplan.vue?vue&type=script&lang=js&"
export * from "./Trainingsplan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bb9236c",
  null
  
)

export default component.exports